require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-z-28-h-4-b-4.json") })
        }
      }, "path---photos-professional-z-28-h-4-b-4");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-z-28-h-4-b-4!./.cache/json/photos-professional-z-28-h-4-b-4.json
// module id = 1089
// module chunks = 231608221292675